import { render } from "./messageServer.vue?vue&type=template&id=5d4899d6"
import script from "./messageServer.vue?vue&type=script&lang=js"
export * from "./messageServer.vue?vue&type=script&lang=js"

import exportComponent from "/jenkins/workspace/zh-center-resource-webui_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__